import { SessionStorageKeys } from '../types/SessionStorage';
import { Storage } from './Storage';

const fieldNames = {
  gender: false,
  height: false,
  weight: false,
  biker: false,
} as const;

export const isFormFieldTouched = (fieldName: string) => {
  const formFieldsFromStorage = Storage.readItem(SessionStorageKeys.FORM_FIELDS_TOUCHED) || '';
  if (formFieldsFromStorage !== '') {
    const formFields = JSON.parse(formFieldsFromStorage);
    return formFields[fieldName];
  }
  return false;
};
export const changeFieldTouched = (fieldName: string) => {
  const formFieldsFromStorage = Storage.readItem(SessionStorageKeys.FORM_FIELDS_TOUCHED) || '';
  if (formFieldsFromStorage === '') {
    return;
  }
  const formFields = JSON.parse(formFieldsFromStorage);
  const touchedField = {
    ...formFields,
    [fieldName]: true
  };
  Storage.writeItem(SessionStorageKeys.FORM_FIELDS_TOUCHED, JSON.stringify(touchedField));
};


export const initFormTochedFields = () => {
  const formFieldsFromStorage = Storage.readItem(SessionStorageKeys.FORM_FIELDS_TOUCHED);
  if(!formFieldsFromStorage) {
    Storage.writeItem(SessionStorageKeys.FORM_FIELDS_TOUCHED, JSON.stringify(fieldNames));
  }
};

export const setTariffOptions = (tarifOption: object) => {
  const tarifOptionsFromStorage = Storage.readItem(SessionStorageKeys.TARIFF_OPTIONS) || '{}';
  const formFields = JSON.parse(tarifOptionsFromStorage);
  Storage.writeItem(SessionStorageKeys.TARIFF_OPTIONS, JSON.stringify({...formFields, ...tarifOption}));
};

export const getTariffOptions = () => {
  const tarifOptionsFromStorage = Storage.readItem(SessionStorageKeys.TARIFF_OPTIONS);
  if (tarifOptionsFromStorage) {
    return JSON.parse(tarifOptionsFromStorage);
  }
  return {};
};
